export interface FieldValidation {
  key: string;
  value: string;
  message: string;
}

export const hasFieldError = (
  fieldName: string,
  errors: { [key: string]: string },
  serverErrorMsg: string | string[],
  formFieldErrorMessages: { [key: string]: string },
) => !!errors[fieldName] || !!serverErrorMsg?.includes(formFieldErrorMessages[fieldName]);

export const validateField = (
  key: string,
  value: string,
  formValidations: FieldValidation[],
  invalidTLDs?: string,
): string => {
  const validation = formValidations?.find((item) => item.key === key);

  if (validation) {
    const regex = new RegExp(validation.value);

    if (key === 'email' && regex.test(value)) {
      const tldPattern = new RegExp(`\\.(${invalidTLDs?.split(',').join('|')})$`, 'i');
      if (tldPattern.test(value)) {
        return validation.message;
      }
      return '';
    }

    if (regex.test(value)) {
      return '';
    }

    return key === 'reservationId' ? 'Please provide valid Reservation number.' : validation.message;
  }

  return '';
};
